/** @format */

import * as React from 'react'

const getDisplayName = Comp => Comp.displayName || Comp.name || 'Component'

const noop = () => null

export const notNull = (keys = [], fallback = noop) => Comp =>
  // eslint-disable-next-line react/prefer-stateless-function
  class extends React.Component {
    static displayName = `@notNull(${getDisplayName(Comp)})`
    render() {
      const props = this.props

      return keys.some(key => props[key] == null) ? (
        fallback(props)
      ) : (
        <Comp {...props} />
      )
    }
  }
